export enum PortalUnsubscribeRoutes {
  UNSUBSCRIBE_ACR = 'acr',
}
